var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotatoPanelLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 73,
    viewBox: "0 0 374 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 67.7538V65.3181L7.01964 65.3181V67.7538H366.826Z",
    fill: "#DFDDDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67976 65.3181H7.01964V62.8824H4.67976V65.3181Z",
    fill: "#DFDDDA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33988 62.8824H4.67976V60.4466H2.33988V62.8824Z",
    fill: "#DFDDDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 65.3181L369.166 65.3181V62.8824H366.826V65.3181Z",
    fill: "#DFDDDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M369.166 62.8824H371.506V60.4466H369.166V62.8824Z",
    fill: "#DFDDDA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 70.1896V67.7538H7.01964V70.1896H366.826Z",
    fill: "#6A6967"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67976 67.7538H7.01964V65.3181H4.67976V67.7538Z",
    fill: "#6A6967"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33988 65.3181H4.67976V62.8824H2.33988V65.3181Z",
    fill: "#6A6967"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 67.7538H369.166V65.3181L366.826 65.3181V67.7538Z",
    fill: "#6A6967"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M369.166 65.3181H371.506V62.8824H369.166V65.3181Z",
    fill: "#6A6967"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 72.6253V70.1896H7.01964L7.01964 72.6253H366.826Z",
    fill: "#1A1918"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M373.846 6.90124H371.506V65.3181H373.846V6.90124Z",
    fill: "#1A1918"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86102e-06 6.90124H2.33988L2.33988 65.3181H0L2.86102e-06 6.90124Z",
    fill: "#1A1918"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M369.166 6.90124H371.506V4.46551H369.166V6.90124Z",
    fill: "#1A1918"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M369.166 67.7538H371.506V65.3181H369.166V67.7538Z",
    fill: "#1A1918"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67976 67.7538H2.33988L2.33988 65.3181H4.67976V67.7538Z",
    fill: "#1A1918"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 70.1896H369.166V67.7538H366.826V70.1896Z",
    fill: "#1A1918"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 70.1896H4.67976L4.67976 67.7538H7.01964V70.1896Z",
    fill: "#1A1918"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33988 6.90124H4.67976V4.46551H2.33988L2.33988 6.90124Z",
    fill: "#1A1918"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 60.8526H9.35952V58.4169H7.01964V60.8526Z",
    fill: "#1A1918"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 0V2.43573H9.35952V0H364.486Z",
    fill: "#1A1918"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 4.87146V2.43573H9.35952V4.87146H7.01964Z",
    fill: "#1A1918"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 4.87146V58.4169H4.67976V4.87146H7.01964Z",
    fill: "#1A1918"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 4.87146V2.43573H364.486V4.87146H366.826Z",
    fill: "#1A1918"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 58.4169H369.166V4.87146H366.826V58.4169Z",
    fill: "#1A1918"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 60.8526V58.4169H366.826V60.8526H364.486Z",
    fill: "#1A1918"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 60.8526H9.35952V63.2883H364.486V60.8526Z",
    fill: "#1A1918"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33988 6.90124H4.67976L4.67976 60.4466H2.33988L2.33988 6.90124Z",
    fill: "#AAA9A6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M371.506 6.90124H369.166V60.4466H371.506V6.90124Z",
    fill: "#AAA9A6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67976 58.4169H7.01964V60.8526H4.67976V58.4169Z",
    fill: "#AAA9A6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M369.166 58.4169H366.826V60.8526H369.166V58.4169Z",
    fill: "#AAA9A6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 63.2883H366.826V65.3181L7.01964 65.3181V63.2883Z",
    fill: "#AAA9A6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67976 60.8526H9.35952V63.2883H4.67976V60.8526Z",
    fill: "#AAA9A6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M369.166 60.8526H364.486V63.2883H369.166V60.8526Z",
    fill: "#AAA9A6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 60.8526V58.4169H9.35952V60.8526H364.486Z",
    fill: "#FFDA58"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 58.4169H9.35952V55.9811H7.01964V58.4169Z",
    fill: "#FFDA58"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 58.4169H366.826V55.9811H364.486V58.4169Z",
    fill: "#FFDA58"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 2.43573V4.87146H9.35952V2.43573H364.486Z",
    fill: "#FFDA58"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 4.87146H9.35952V7.3072H7.01964V4.87146Z",
    fill: "#FFDA58"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 4.87146H366.826V7.3072H364.486V4.87146Z",
    fill: "#FFDA58"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 7.3072H9.35952V9.74292H7.01964V7.3072Z",
    fill: "#FFFCF4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01964 55.9811H9.35952V53.5454H7.01964V55.9811Z",
    fill: "#FFFCF4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 7.3072H364.486V9.74292H366.826V7.3072Z",
    fill: "#FFFCF4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M366.826 55.9811H364.486V53.5454H366.826V55.9811Z",
    fill: "#FFFCF4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35952 4.87146H11.6994V7.30719L9.35952 7.3072V4.87146Z",
    fill: "#FFFCF4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35952 58.4169H11.6994V55.9811H9.35952V58.4169Z",
    fill: "#FFFCF4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 4.87146H362.146V7.30719L364.486 7.3072V4.87146Z",
    fill: "#FFFCF4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M364.486 58.4169H362.146V55.9811H364.486V58.4169Z",
    fill: "#FFFCF4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35952 9.74292H7.01964V53.5454H9.35952V55.9811H11.6994V58.4169H362.146V55.9811H364.486V53.5454H366.826V9.74292H364.486V7.3072L362.146 7.30719V4.87146H11.6994V7.30719L9.35952 7.3072V9.74292Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotatoPanelLong);
export default __webpack_public_path__ + "static/media/cotato_panel_long.4da9939419666af6507f128dcec278dc.svg";
export { ForwardRef as ReactComponent };